const loadjQuery = (callback) => {
    const existingScript = document.getElementById('jQuery');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://code.jquery.com/jquery-2.2.4.min.js';
      script.id = 'jQuery';
      document.body.appendChild(script);
      script.onload = () => { 
        if (callback) callback();
      };
    }
    if (existingScript && callback) callback();
  };
  export default loadjQuery;